import { configureStore } from '@reduxjs/toolkit'
import userReducer from './userSlice/userSlice'
import snackbarReducer from './snackbarSlice/snackbarSlice'

export default configureStore({
  reducer: {
    user: userReducer,
    snackbar: snackbarReducer
  }
})